import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const testimonials = [{
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Mendoza',
  product: 'Kit + Acelerador 10X',
  quote: 'El Protocolo de Muerte Súbita me ahorró semanas de testeo. Detecté en 2 horas que mi Pixel no estaba registrando compras. Eso hubiera destruido toda mi primera campaña.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  product: 'Kit Máquina de Ventas',
  quote: 'El Blindaje Financiero me mostró que estaba mezclando la plata del negocio con la personal. En 30 días ordené todo y por primera vez sé exactamente cuánto gano.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  product: 'Kit Máquina de Ventas',
  quote: 'El Calendario de 90 Días fue lo que me faltaba. Tenía toda la información pero no sabía en qué orden implementarla. El mapa día a día cambió todo.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Neuquén',
  product: 'Kit + Acelerador 10X',
  quote: 'El Método Cama de Presupuesto me permitió escalar de $2.000 a $8.000 ARS diarios en 5 semanas sin que el CPA se disparara. Eso vale 10 veces el precio del Kit.'
}];
const faqs = [{
  q: '¿Sirve si nunca vendí nada online?',
  a: 'Sí. El sistema empieza desde cero absoluto. El Tomo I trabaja la mentalidad antes de tocar cualquier herramienta técnica. No se asume conocimiento previo de ningún tipo.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Inmediatamente después de la compra recibís un email con los 12 links de descarga. Acceso en menos de 5 minutos desde cualquier dispositivo.'
}, {
  q: '¿Lo puedo implementar si tengo trabajo de tiempo completo?',
  a: 'Sí. El sistema está diseñado específicamente para personas con trabajo de 9 a 18. El Tomo I incluye el sistema de bloques de 90 minutos para construir el negocio en paralelo.'
}, {
  q: '¿Tiene garantía real?',
  a: '30 días completos. Si implementás y no vale lo que pagaste, te devolvemos el 100% sin preguntas. El riesgo es completamente nuestro.'
}];
const costComparison = [{
  sin: 'Sin sistema de nicho con datos',
  costo: 'Meses probando ángulos que no convierten'
}, {
  sin: 'Sin estructura de oferta',
  costo: 'Precio bajo que no cubre los costos de publicidad'
}, {
  sin: 'Sin protocolo de Meta Ads',
  costo: 'Plata quemada en ads que no venden'
}, {
  sin: 'Sin secuencias de email',
  costo: 'Leads que se enfrían y nunca compran'
}, {
  sin: 'Sin sistema de cierre por WhatsApp',
  costo: 'Conversaciones que terminan en "lo pienso"'
}, {
  sin: 'Sin Calendario de 90 Días',
  costo: 'Parálisis por análisis que dura meses'
}, {
  sin: 'Próximo lunes sin sistema',
  costo: 'El mismo ciclo, el próximo año'
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="bg-neutral-950 border border-neutral-800 rounded-2xl overflow-hidden" data-id="element-181">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-5 md:p-6 text-left font-bold text-base md:text-lg text-white hover:text-[#D4AF37] transition-colors" data-id="element-182">
        <span data-id="element-183">{q}</span>
        <svg className={`w-5 h-5 text-gray-500 shrink-0 ml-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-184">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-185" />
        </svg>
      </button>
      {open && <div className="px-5 md:px-6 pb-5 md:pb-6 text-gray-400 leading-relaxed text-sm md:text-base border-t border-neutral-800/50" data-id="element-186">
          <div className="pt-4" data-id="element-187">{a}</div>
        </div>}
    </div>;
}
export function TrustSection() {
  return <section className="py-16 md:py-24 bg-[#0A0A0A] border-t border-neutral-800" data-id="element-188">
      <div className="max-w-6xl mx-auto px-4" data-id="element-189">
        {/* Testimonials */}
        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-16" data-id="element-190">
          ❤️ MÁS EMPRENDEDORES QUE YA LO TIENEN
        </h2>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-191">
          {testimonials.map((t, i) => <div key={i} className="bg-neutral-950 border border-neutral-800 rounded-2xl p-6 md:p-8" data-id="element-192">
              <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-193">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#D4AF37]/10 text-[#D4AF37] flex items-center justify-center font-bold text-base md:text-xl border border-[#D4AF37]/30" data-id="element-194">
                  {t.initials}
                </div>
                <div data-id="element-195">
                  <div className="text-[#D4AF37] text-xs tracking-wider mb-0.5" data-id="element-196">
                    ★★★★★
                  </div>
                  <div className="text-white font-bold text-sm md:text-base" data-id="element-197">
                    {t.name}{' '}
                    <span className="text-gray-500 font-normal text-xs md:text-sm ml-1" data-id="element-198">
                      📍 {t.location}
                    </span>
                  </div>
                  <div className="text-xs text-[#D4AF37]/80 font-medium mt-0.5" data-id="element-199">
                    | {t.product}
                  </div>
                </div>
              </div>
              <p className="text-gray-300 italic text-sm md:text-lg leading-relaxed" data-id="element-200">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-neutral-800 to-neutral-900 border border-neutral-700 rounded-2xl md:rounded-3xl p-8 md:p-14 text-center mb-20 md:mb-28 relative overflow-hidden" data-id="element-201">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-[#B8941F] via-[#E5C158] to-[#B8941F]" data-id="element-202" />
          <div className="text-6xl md:text-7xl mb-6" data-id="element-203">🛡️</div>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-5" data-id="element-204">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-205">
            Abrís los tomos. Los implementás en tu negocio.
            <br data-id="element-206" />
            Si en 30 días de implementación honesta no considerás
            <br data-id="element-207" />
            que vale al menos 10 veces lo que pagaste:
            <br data-id="element-208" />
            <strong className="text-white" data-id="element-209">devolución del 100%</strong>
            <br data-id="element-210" />
            sin formularios, sin drama.
          </p>
          <div className="inline-block bg-neutral-950 px-5 py-2.5 rounded-full text-[#D4AF37] font-medium border border-[#D4AF37]/30 text-sm" data-id="element-211">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-20 md:mb-28" data-id="element-212">
          <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-12" data-id="element-213">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-3 md:space-y-4" data-id="element-214">
            {faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} data-id="element-215" />)}
          </div>
        </div>

        {/* Cost Comparison */}
        <div className="max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-216">
          <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-12" data-id="element-217">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <div className="bg-neutral-950 border border-neutral-800 rounded-2xl md:rounded-3xl overflow-hidden" data-id="element-218">
            <div className="overflow-x-auto" data-id="element-219">
              <table className="w-full text-left min-w-[500px]" data-id="element-220">
                <thead data-id="element-221">
                  <tr className="bg-neutral-800/60" data-id="element-222">
                    <th className="p-4 md:p-6 text-gray-300 font-semibold text-sm border-b border-neutral-700 w-1/2" data-id="element-223">
                      Sin Kit Máquina de Ventas
                    </th>
                    <th className="p-4 md:p-6 text-red-400 font-semibold text-sm border-b border-neutral-700 w-1/2" data-id="element-224">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-225">
                  {costComparison.map((row, i) => <tr key={i} className="border-b border-neutral-800/50 hover:bg-neutral-800/20 transition-colors" data-id="element-226">
                      <td className="p-4 md:p-6 text-white font-medium text-sm" data-id="element-227">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-gray-400 text-sm" data-id="element-228">
                        {row.costo}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="max-w-4xl mx-auto text-center bg-neutral-950 border border-[#D4AF37]/30 rounded-2xl md:rounded-3xl p-6 md:p-14 relative overflow-hidden" data-id="element-229">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[250px] rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(212,175,55,0.10) 0%, transparent 70%)'
        }} data-id="element-230" />

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 relative z-10" data-id="element-231">
            El próximo lunes puede ser diferente.
          </h2>

          <div className="mb-10 relative z-10" data-id="element-232">
            <div className="text-red-500 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-233">
              ⏰ EL PRECIO CIERRA EN:
            </div>
            <CountdownTimer data-id="element-234" />
          </div>

          <div className="flex flex-col md:flex-row gap-4 md:gap-6 justify-center relative z-10 mb-10" data-id="element-235">
            <a href="https://www.nexorecursos.com/cart/52508914876692:1" className="flex-1 bg-neutral-800 hover:bg-neutral-700 text-white font-bold py-5 px-6 rounded-2xl transition-colors border border-neutral-700 flex flex-col items-center justify-center gap-1" data-id="element-236">
              <span className="text-lg md:text-xl" data-id="element-237">
                KIT MÁQUINA DE VENTAS™
              </span>
              <span className="text-[#D4AF37] font-bold" data-id="element-238">$24.990 ARS</span>
              <span className="text-xs font-normal text-gray-400 mt-1" data-id="element-239">
                → QUIERO MI KIT AHORA
              </span>
            </a>
            <a href="https://www.nexorecursos.com/cart/52508916187412:1" className="animate-pulse-glow flex-1 bg-gradient-to-b from-[#E5C158] to-[#D4AF37] hover:from-[#F0CF6E] hover:to-[#E5C158] text-black font-bold py-5 px-6 rounded-2xl transition-all active:scale-95 flex flex-col items-center justify-center gap-1" data-id="element-240">
              <span className="text-lg md:text-xl" data-id="element-241">
                KIT + ACELERADOR 10X ⭐
              </span>
              <span className="text-black font-bold" data-id="element-242">$32.990 ARS</span>
              <span className="text-xs font-bold text-neutral-900 mt-1" data-id="element-243">
                → QUIERO EL KIT + ACELERADOR 10X
              </span>
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm font-medium text-gray-500 relative z-10" data-id="element-244">
            <span data-id="element-245">🔒 Pago 100% seguro</span>
            <span data-id="element-246">⚡ Acceso en 5 minutos</span>
            <span data-id="element-247">🛡️ Garantía 30 días</span>
            <span data-id="element-248">💳 Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}